export const CollectionConstant = {
    CATEGORY: "Payment",
    TITLE: "Payment Details",
    SEARCH_CRITERIA: "Search Criteria",
    DRAFT_INVOICE_NO: "Draft Invoice No.",
    FINAL_INVOICE_NO: "Final Invoice No.",
    BILLTO_COMPANY: "Bill-To Company",
    AGENT_NO: "Agent No.",
    RECEIPT_NO: "Receipt No.",
    SUB_TYPE: "Sub Type",
    DOC_DATE: "Doc. Date",
    TOTAL_AMOUNT: "Total Invoice Amount",
    PAYMENT_AMOUNT: "Payment Amount",
    REFUND_AMOUNT: "Refund Amount",
    CREATED_BY: "Created By",
    CREATED_DATE: "Created Date",
    CHANGED_BY: "Changed By",
    CHANGED_DATE: "Changed Date",
    DATE_RANGE: "Date Range",
    COLLECTION_DATE_RANGE: "Collection Date Range",
    UPDATE_BY: "Update By",
    NOT_YET_FINAL: "Not yet final",
    PAYMENT_MODE: "Payment Mode",
    PAY_ORDER_NO: "Pay Order No.",
    AGENT_NAME: "Agent Name",
    PAYEE_NAME: "Payee Name",
    BANK_CODE: "Bank Code",
    PAY_ORDER_AMOUNT: "Pay Order Amount",
    BALANCE: "Balance",
    REMARK: "Remark",
    PO_EXCESS_AMOUNT: "PO Excess Amount",
    PORTAL_PAYMENT_MODE: "Portal Payment Mode",
    PAYEE: "Payee",
    OBSERVATION: "observation",
}